
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value', 'input', 'change'],
    setup(_, { emit }) {
        const emitUpdate = (event: Event) => {
            const target = event.target as HTMLInputElement
            const value = target.value

            emit('update:value', value)
            emit('input', value)
        }

        const emitChange = (event: Event) => {
            const target = event.target as HTMLInputElement
            const value = target.value

            emit('change', value)
        }

        return { emitUpdate, emitChange }
    },
})
